<template>
    <v-container grid-list-md fluid>
        <!-- <img class="text-center" width="300" alt="Master Meal Planner logo" src="@/assets/logo.png" id="logo" @click="goToPath('/')">
        <div class="mmp-title">Master Meal Planner</div> -->
        
        <div class="white-card">

            <h1 class="content-title">Newsfeed</h1>    
            <h2 class="content-subTitle">Sub Title</h2>

            <div class="content-body">
                Cotent Area ...
            </div>

        </div>
    </v-container>
</template>

<script>
    export default {
        name: "Newsfeed",
        props: {
            // msg: String
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },
        },
        methods: {
            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                this.$router.push(path);
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }
    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }
    a {
        color: #42b983;
    }
    .mmp-title {
        text-align:center;
        font-size:48px;
        font-weight:bold;
        margin-bottom:10px;
    }
    .greeting {
        margin: auto;
    }
    .content-title {
        text-align:center;
        font-size:32px;
        font-weight:bold;
    }
    .content-subTitle {
        padding-left: 10px;
        font-size:24px;
        font-weight:bold; 
    }
    .content-body {
        padding: 10px;
        font-size:18px;        
    }
</style>
